/**
 * @generated SignedSource<<0112200ad1f4a80a18ef75dc585b47ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuctionLotStatus = "DRAFT" | "OPEN" | "PAUSED" | "CLOSED" | "CANCELED" | "DELETED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useAuctionState_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly relevantAuctionLot: {
    readonly status: AuctionLotStatus | null;
    readonly startDate: string | null;
    readonly endDate: string | null;
  } | null;
  readonly relevantAuctionSolution: {
    readonly reserveMet: boolean | null;
  } | null;
  readonly " $fragmentType": "useAuctionState_item";
};
export type useAuctionState_item$key = {
  readonly " $data"?: useAuctionState_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionState_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuctionState_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reserveMet",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "f777a7fba2280e727ea15e5166072282";

export default node;
